export default __webpack_public_path__ + "static/media/git.cf89d743.svg";